import Vue from 'vue';

export default {
    customPieChart(form, field, period) {
        return Vue.http.get(`graphs/form/${form}/field/${field}?period=${period}`);
    }
}
